import { render, staticRenderFns } from "./LinkTypeMoreInfo.vue?vue&type=template&id=484f489b&scoped=true"
import script from "./LinkTypeMoreInfo.vue?vue&type=script&lang=js"
export * from "./LinkTypeMoreInfo.vue?vue&type=script&lang=js"
import style0 from "./LinkTypeMoreInfo.vue?vue&type=style&index=0&id=484f489b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484f489b",
  null
  
)

export default component.exports